import { takeEvery, put, call } from 'redux-saga/effects';

import { paperworkCommonActions } from '../actions/common';
import { redirectToPaperworkVisitDetails } from '../../../utils/paperwork/redirect-utils';
import { actions as loggedUserActions } from '../../context/loggedUser';
import { actions as paperworkVerifyDobActions } from '../requests/paperwork-verify-dob';
import { actions as paperworkAppointmentSessionActions } from '../requests/paperwork-appointment-session';

import { getAppointmentId } from '../../../utils/paperwork';
import { PAPERWORK_TOKEN } from '../../../constants/storageKeys';

function* selectPaperworkFlowVerifiedUserDataSagaWorker({ payload }) {
  const uuid = getAppointmentId();

  const { authenticationToken } = payload || {};

  if (authenticationToken) {
    window.storage.setItem(
      PAPERWORK_TOKEN,
      JSON.stringify(authenticationToken),
    );
  }

  yield put(paperworkCommonActions.setGlobalPaperworkPending(false));

  yield put(loggedUserActions.add(payload));

  yield call(redirectToPaperworkVisitDetails, uuid);

  // Dispatch validate here in addition to the useEffect in the Paperwork component,
  // because if isLoggedIn was already true before OTP (e.g. Tab 2 inherited another
  // tab's session), the useEffect won't re-fire when the OTP token replaces it.
  yield put(paperworkCommonActions.validate());
}

export function* selectPaperworkFlowVerifiedUserDataSaga() {
  yield takeEvery(
    [
      paperworkVerifyDobActions.succeed,
      paperworkAppointmentSessionActions.succeed,
    ],
    selectPaperworkFlowVerifiedUserDataSagaWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/paperwork/sagas/set-paperwork-flow-verified-user-data.js